import React from "react";
const {Helmet} = require("react-helmet");
import Layout from "../components/layout/layout";
import useIndexData from "../components/indexData";
import {MoreArticles} from "../components/moreArticles/moreArticles";
import {StrapiLayout, Jumbo} from "@klear/open-site";

const styles = require("../styles/index.module.scss");
const topImage = "https://klear.com/images/new/tosHeader.gif";

declare global {
    interface Document {
        documentMode: number;
    }
}

export default () => {
    const allData = useIndexData();
    const allStrapiCaseStudy = allData.allStrapiCaseStudy;
    const footerData = allData.strapiFooter;
    const indexAllStrapiCaseStudy = allStrapiCaseStudy.edges;

    return (
        <StrapiLayout footerProps={footerData}>
            <Helmet>
                <title>Case Studies | Klear</title>
                <meta name="description"
                      content="Learn how the world’s leading brands have found success with Klear"/>
            </Helmet>
            <Layout>
                <div className={styles.container}>
                    <Jumbo title="Klear Case Studies"
                           subTitle="Learn how the world’s leading brands have found success with Klear"
                           topImage={topImage}
                    />
                    <MoreArticles isCategoryPage={false}
                                  mainTitle={''}
                                  posts={indexAllStrapiCaseStudy}/>
                </div>
            </Layout>
        </StrapiLayout>
    );
};